export const GET_USER_SETTINGS = 'getUserSettings';